import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { captureException } from '@sentry/react-router';

import OffersListComponent, { type OffersListIndexProps } from '@cx-modules/offers-list';

import { useOffersClickoutServiceProps } from '~/modules/offers-clickout';

export const OffersList = (props: Omit<OffersListIndexProps, 'i18n' | 'clickoutServiceUrl'>) => {
  const { i18n } = useTranslation();
  const clickoutServiceProps = useOffersClickoutServiceProps(props.gtmId, props.fullPageUrl);

  const filtersThreshold = ['IT'].includes(props.repub) ? 2 : Infinity;

  const preconfiguredProps = {
    ...props,
    ...clickoutServiceProps,
    filtersThreshold,
    clickoutServiceUrl: ENV.CLICKOUT_URL,
    i18n,
  };

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        captureException(error);
        return null;
      }}
    >
      <Suspense fallback={null}>
        <div
          data-country-code={props.countryCode}
          data-geo-subdivision-code={props.geoSubdivisionCode}
          data-lang={i18n.language}
          data-repub={props.repub}
          data-subdivision-code={props.subdivisionCode}
        >
          <OffersListComponent {...preconfiguredProps} />
        </div>
      </Suspense>
    </ErrorBoundary>
  );
};
